import { useState, useMemo } from 'react';
import { RebalanceReportColumn } from '../sharedTypes';

function useTableSort<T>(
  initialColumns: RebalanceReportColumn<T>[],
  column: keyof T | null = null,
  direction: 'asc' | 'desc' | undefined = undefined,
) {
  const [sortColumn, setSortColumn] = useState<keyof T | null>(column);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc' | undefined>(direction);

  const handleSort = (columnAccessor: keyof T) => {
    if (sortColumn === columnAccessor) {
      setSortDirection((prev) => {
        if (prev === 'asc') return 'desc';
        if (prev === 'desc') return undefined;
        return 'asc';
      });
    } else {
      setSortColumn(columnAccessor);
      setSortDirection('asc');
    }
  };

  const sortedColumns = useMemo(() => (
    initialColumns.map((sortedColumn) => {
      if (sortedColumn.accessor === sortColumn) {
        return { ...sortedColumn, sorted: sortDirection };
      }
      return { ...sortedColumn, sorted: undefined };
    })
  ), [initialColumns, sortColumn, sortDirection]);

  return {
    sortColumn,
    sortDirection,
    handleSort,
    sortedColumns,
  };
}

export default useTableSort;
